
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { rulesForms } from "@/core/RulesForm";
import { Action } from "@/core/CommonDefinition";

@Component
export default class MotDePasse extends Vue {
  @Prop() action!: Action;
  Action: any = Action;
  regleFormulaire: any = rulesForms;
  @Prop() ancienMotDePasse!: string;
  @Prop() nouveauMotDePasse!: string;
  confirmationNouveauMotDePasse: string = "";
  show: boolean = false;
  @Prop() isDisableForm!: boolean;
  @Prop() linkIsExpired: boolean | undefined;

  get AncienMotDePasse() {
    return this.ancienMotDePasse;
  }
  set AncienMotDePasse(value: string) {
    this.$emit("update:ancienMotDePasse", value);
  }

  get NouveauMotDePasse() {
    return this.nouveauMotDePasse;
  }
  set NouveauMotDePasse(value: string) {
    this.$emit("update:nouveauMotDePasse", value);
  }

  get regleMotDePasse() {
    return () =>
      this.confirmationNouveauMotDePasse === "" ||
      this.nouveauMotDePasse === this.confirmationNouveauMotDePasse ||
      "La confirmation du mot de passe ne correspond pas au mot de passe saisi";
  }

  get regleConfirmationMotDePasse() {
    return () =>
      this.nouveauMotDePasse === this.confirmationNouveauMotDePasse ||
      this.confirmationNouveauMotDePasse === "" ||
      "La confirmation du mot de passe ne correspond pas au mot de passe saisi";
  }

  @Watch("nouveauMotDePasse")
  motDepasse(): void {
    if (this.confirmationNouveauMotDePasse != "") {
      (this.$refs.form as Vue & { validate: () => boolean }).validate();
    }
  }

  validate(): boolean {
    return (this.$refs.form as Vue & { validate: () => boolean }).validate();
  }

  clear(): void {
    (this.$refs.form as HTMLFormElement).resetValidation();
    this.confirmationNouveauMotDePasse = "";
  }

  allerPasswordReset(): void {
    this.$router.push({ name: "Login" });
  }
}
